<template>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col class="text-center" cols="12" md="6">
          <v-img :src="logo" alt="Logo" max-height="200" class="mb-4"></v-img>
          <h1 class="display-2 font-weight-bold mb-2">403</h1>
          <h2 class="headline font-weight-normal mb-2">Not Authorized</h2>
          <p class="subtitle-1 mb-5">
            Sorry, you do not have permission to view this page. Please contact the administrator if you believe this is an error.
          </p>
          <v-btn large color="primary" :to="{ name: 'Home' }">Go to Home</v-btn>
          <v-btn large text :to="{ name: 'contact' }">Contact Support</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  export default {
    name: "NotAuthorized",
    data() {
      return {
        logo: require('@/assets/FactsLogoBg.png') // Ensure the path is correct
      };
    }
  };
  </script>
  
  <style scoped>
  </style>